import React from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from 'react-native'
import { Txt } from '../../../../components'
import { getMonthWeekDayFormat } from '../../../../tools/dataParse'
import { usePlatforms } from '../../../../hooks/usePlatforms'
import Identity from '../../../../utils/Identity'
import { useTheme } from '../../../../theming/ThemeProvider'
import useStyles from '../../../../components/Cards/useStyles'

const PaymentCard = ({ item, payoutTermsTypes }) => {
  const { ActualPaidDate, NetAmount, InvoiceNo, PayoutTermCode } = item
  const { isTablet, isDesktop } = usePlatforms()
  const { theme } = useTheme()
  const styles = {
    ...useStyles(theme, isTablet, isDesktop),
    ...useLocalStyles(isTablet)
  }
  const payoutTerm = payoutTermsTypes.find(type => type.PayoutTermCode === PayoutTermCode)

  return (
    <View style={[styles.cardStyle, Identity.Shadow(theme).Card]}>
      <View style={{ flex: 1, flexDirection: isTablet ? 'row' : 'column', flexWrap: 'wrap' }}>
        <View style={styles.firstRow}>
          <View style={[styles.item, styles.leftItem]}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={InvoiceNo || '- -'}
            />
            <Txt
              color='SLATE_GRAY'
              text='Invoice #'
              identity='body3'
            />
          </View>
          <View style={styles.item}>
            <Txt
              color='SLATE_GRAY'
              identity='body1Bold'
              text={
                ActualPaidDate
                  ? getMonthWeekDayFormat(ActualPaidDate)
                  : '--'
              }
              style={styles.rightText}
            />
            <Txt
              color='SLATE_GRAY'
              text='Pay Date'
              identity='body3'
              style={styles.rightText}
            />
          </View>
        </View>
        <View style={styles.secondRow}>
          <View style={[styles.item, styles.leftItem]}>
            <Txt
              color='SLATE_GRAY'
              text={payoutTerm ? payoutTerm.Name : '--'}
              identity='body1Bold'
            />
            <Txt
              color='SLATE_GRAY'
              text='Payout Term'
              identity='body3'
            />
          </View>
          <View style={styles.item}>
            <Txt
              color='FERN'
              identity='body2Bold'
              text={`$ ${NetAmount || '--'} USD`}
              style={styles.rightText}
            />
            <Txt
              color='SLATE_GRAY'
              text='Payout'
              identity='body3'
              style={styles.rightText}
            />
          </View>
        </View>
      </View>
    </View>
  )
}

const useLocalStyles = (isTablet) => StyleSheet.create({
  firstRow: {
    flex: 1,
    width: isTablet ? 'auto' : '100%',
    flexDirection: 'row',
    justifyContent: isTablet ? 'space-around' : 'space-between',
    marginBottom: isTablet ? 0 : 20
  },
  secondRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: isTablet ? 'space-around' : 'space-between',
    width: isTablet ? 'auto' : '100%'
  },
  item: {
    minWidth: 100
  },
  leftItem: {
    marginRight: 30
  },
  rightText: {
    textAlign: isTablet ? 'left' : 'right'
  }
})

PaymentCard.propTypes = {
  item: PropTypes.object.isRequired,
  payoutTermsTypes: PropTypes.array
}

export default PaymentCard
